import { InsType } from 'constants/enums/insType.enum';
import React, { useRef, useState, useEffect } from 'react';
import { IProps } from './types';
import moment from 'moment';
import commonService from 'utils/commonService';
import { useSelector } from 'react-redux';
import { RootReducersState } from 'redux/reducers';

const List: React.FC<IProps> = (props) => {
  const resources = useSelector((state: RootReducersState) => state.resources);
  const listRef = useRef<HTMLDivElement>(null);
  const [listElemHeight, setListElemHeight] = useState(0);

  useEffect(() => {
    const listElemHeight = (props.detailOpen && listRef && listRef.current) ? listRef.current.clientHeight : 0;
    setListElemHeight(listElemHeight);
  }, [props.detailOpen, props.INS_TYPE_ID]);

  return (
    <div className="insured-content__list" style={{ height: listElemHeight }}>
      <div className="insured-content__list-container" ref={listRef}>
        <div className="element__list">
          {
            props.INS_TYPE_ID && props.INS_TYPE_ID === InsType.Travel && (
              <>
                <div className="element__list-col">
                  <div className="element__list-group">
                    <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Insured_period')}</div>
                    <div className="element__list-group-content">{props.INS_PERIOD}</div>
                  </div>
                </div>
                <div className="element__list-col">
                  <div className="element__list-group">
                    <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Tourist_destination')}</div>
                    <div className="element__list-group-content">{props.DESTINATION_ID ? props.DESTINATION_ID.join('、') : '-'}</div>
                  </div>
                </div>
                <div className="element__list-col">
                  <div className="element__list-group">
                    <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Insurance_name')}</div>
                    <div className="element__list-group-content">{props.PRODUCT_NAME}</div>
                  </div>
                </div>
                <div className="element__list-col">
                  <div className="element__list-group">
                    <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Insurance_type_travel')}</div>
                    <div className="element__list-group-content">{props.PLAN_DESC}</div>
                  </div>
                </div>
                <div className="element__list-col">
                  <div className="element__list-group">
                    <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_English_insurance_cert')}</div>
                    <div className="element__list-group-content">
                      {props.INSURANCE_CERTIFICATE_EN ? props.INSURANCE_CERTIFICATE_EN : '-'}
                    </div>
                  </div>
                </div>
                {/* <div className="element__list-col">
                  <div className="element__list-group">
                    <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Transportation')}</div>
                    <div className="element__list-group-content">{props.TRANSPORT}</div>
                  </div>
                </div> */}
                <div className="element__list-col">
                  <div className="element__list-group">
                    <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Number_of_insured_persons')}</div>
                    <div className="element__list-group-content">{`${props.PEOPLE}人`}</div>
                  </div>
                </div>
                <div className="element__list-col">
                  <div className="element__list-group">
                    <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Specific_activities')}</div>
                    <div className="element__list-group-content">
                      {props.SPI_ACTIVITY ? props.SPI_ACTIVITY : '-'}
                    </div>
                  </div>
                </div>
              </>
            )
          }
          {
            props.INS_TYPE_ID && (props.INS_TYPE_ID === InsType.Car || props.INS_TYPE_ID === InsType.Moto) && (
              <>
                <div className="element__list-col">
                  <div className="element__list-group">
                    <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Insured_period')}</div>
                    {/* 強制險 */}
                    {props.COMPULSORY_DATE && (
                      <div className="element__list-group-content">{`${commonService.getNameByLng(resources, 'TID_CALI_effdate:')} ${moment(props.COMPULSORY_DATE)?.format('YYYY/MM/DD')}`}</div>
                    )}
                    {/* 任意險 */}
                    {props.VOLUNTARY_DATE && (
                      <div className="element__list-group-content">{`${commonService.getNameByLng(resources, 'TID_Optional_Insurance_effdate:')} ${moment(props.VOLUNTARY_DATE)?.format('YYYY/MM/DD')}`}</div>
                    )}
                  </div>
                </div>
                {
                  props.INS_TYPE_ID && props.INS_TYPE_ID === InsType.Moto && (
                    <div className="element__list-col">
                      <div className="element__list-group">
                        <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Insurance_period')}</div>
                        <div className="element__list-group-content">{props.INS_ANUAL}</div>
                      </div>
                    </div>
                  )
                }
              </>
            )
          }
          {
            props.INS_TYPE_ID && props.INS_TYPE_ID === InsType.Fire && (
              <div className="element__list-col">
                <div className="element__list-group">
                  <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Insured_period')}</div>
                  <div className="element__list-group-content">
                    <p>
                      {
                        props.INSURANCE_PERIOD ? props.INSURANCE_PERIOD : '-'
                      }
                    </p>
                  </div>
                </div>
              </div>
            )
          }
          {
            props.INS_TYPE_ID && props.INS_TYPE_ID === InsType.MobileDevice && (
              <div className="element__list-col">
                <div className="element__list-group">
                  <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Insured_period')}</div>
                  <div className="element__list-group-content">
                    <p>
                      {
                        props.MOBILE_START_DATE && props.MOBILE_END_DATE ? `${props.MOBILE_START_DATE}-${props.MOBILE_END_DATE}` : '-'
                      }
                    </p>
                  </div>
                </div>
              </div>
            )
          }
          {
            props.INS_TYPE_ID && props.INS_TYPE_ID === InsType.Pet && (
              <div className="element__list-col">
                <div className="element__list-group">
                  <div className="element__list-group-title">{commonService.getNameByLng(resources, 'TID_Insured_period')}</div>
                  <div className="element__list-group-content">
                    <p>
                      {
                        props.PET_START_DATE && props.PET_END_DATE ? `${props.PET_START_DATE}-${props.PET_END_DATE}` : '-'
                      }
                    </p>
                  </div>
                </div>
              </div>
            )
          }
        </div>
      </div>
    </div>
  );
};

export default List;
